import { render, staticRenderFns } from "./editTabLampiran.vue?vue&type=template&id=2e795bd1&scoped=true"
import script from "./editTabLampiran.vue?vue&type=script&lang=js"
export * from "./editTabLampiran.vue?vue&type=script&lang=js"
import style0 from "./editTabLampiran.vue?vue&type=style&index=0&id=2e795bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e795bd1",
  null
  
)

export default component.exports